export default {
    namespaced: true,

    state: {
        jwt: {
            access_token: '',
            role_id: 0
        },
        info: {
            username: '',
            email: ''
        }
    },

    getters: {

    },

    mutations: {
        SET_JWT(state, jwt, role_id) {
            state.jwt = jwt
            state.role_id = role_id
        },
        SET_INFO(state, info) {
            state.info = info
        }
    },

    actions: {
        set_jwt({ commit }, jwt, role_id) {
            commit('SET_JWT', jwt, role_id)
        },
        set_info({ commit }, info) {
            commit('SET_INFO', info)
        }
    }
}
